<script lang="ts">
  export let headerText: string;
  export let emoji: string;
  export let onChange: (expanded: boolean) => void;

  let expanded: boolean = false;
</script>

<div class="pina-collapsible">
  <div
    class="pina-collapsible-header"
    aria-expanded={expanded}
    on:click={() => {
      expanded = !expanded;
      if (onChange) onChange(expanded);
    }}
  >
    {emoji} &nbsp;&nbsp; {headerText}
    <svg viewBox="0 0 20 20" fill="none">
      <path class="vert" d="M10 1V19" stroke="black" stroke-width="2" />
      <path d="M1 10L19 10" stroke="black" stroke-width="2" />
    </svg>
  </div>

  <div class="contents" hidden={!expanded}>
    <div class="p" />
    <slot />
  </div>
</div>

<style lang="scss">
  .pina-collapsible {
    padding-bottom: 15px;
    border-bottom: 1px solid var(--gray-light, #eee);
    margin: 0 5px 1.5rem 5px;

    .pina-collapsible-header {
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-weight: 500;

      &:hover {
        cursor: pointer;
      }

      &[aria-expanded="true"] {
        svg {
          transform: rotate(45deg);
        }
      }
    }

    .contents .p {
      font-weight: 400;
    }
  }

  svg {
    height: 0.7em;
    width: 0.7em;
    min-height: 0.7em;
    min-width: 0.7em;
  }
</style>
